/**
 * @param {string} version1
 * @param {string} version2
 * @return {number}
 */
interface IcompareVersion {
  (version1: string, version2: string): 0 | -1 | 1
}
const compareVersion: IcompareVersion = function(version1, version2) {
  const v1Arr = version1.split('.')
  const v2Arr = version2.split('.')
  let i = 0
  while (i < v1Arr.length || i < v2Arr.length) {
    const v1 = parseInt(v1Arr[i] || '0')
    const v2 = parseInt(v2Arr[i] || '0')
    if (v1 > v2) {
      return 1
    }
    if (v1 < v2) {
      return -1
    }
    i++
  }
  return 0
}
export default compareVersion
